<template>
  <div class="relative">
    <SectionNav v-if="!isMobile" />

    <div class="main-section" v-bind:class="{ 'main-section-mobile': isMobile }">
      <Welcome />
      <WMS v-if="!isMobile" />
    </div>
    <div class="viewport-section">
      <industries />
    </div>
    <div class="normal-section">
      <ProcessMap />
    </div>
    <div class="normal-section">
      <Partners />
    </div>
    <InsightModal v-if="showInsightModal" />
  </div>
</template>

<script>
import SectionNav from "../components/SectionNav.vue";
import Welcome from "../components/Welcome.vue";
import WMS from "../components/WMS.vue";
import Industries from "../components/Industries.vue";
import ProcessMap from "../components/ProcessMap.vue";
import Partners from "../components/Partners.vue";
import InsightModal from "../components/InsightModal.vue";

export default {
  name: "Home",
  computed: {
    showInsightModal() {
      return this.$store.state.showInsightModal;
    },
    isMobile() {
      return window.innerWidth < 1000;
    }
  },
  components: {
    SectionNav,
    Welcome,
    WMS,
    Industries,
    ProcessMap,
    Partners,
    InsightModal
  },
  methods: {}
};
</script>

<style>
.main-section {
  width: 100vw;
  height: 200vh;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  background-image: url("../assets/visionback-min.jpg");
  background-size: cover;
  background-position: center;
}

.main-section-mobile {
  height: 100vh;
}

.viewport-section {
  width: 100vw;
  height: 100vh;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.normal-section {
  width: 100vw;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
}
</style>
